import React from "react"
import PropTypes from "prop-types"
import { useStats } from 'react-instantsearch';
function Stats(){

  const { nbHits, query } = useStats();

   return ( <div className="search__stats">
        {nbHits} result{nbHits !== 1 && "s"}
        {query
            ? <span> for <span className="text--red">{query}</span></span>
            : null}
    </div>)
}
Stats.propTypes = {
    nbHits: PropTypes.number,
	query: PropTypes.string,
};
export default Stats